import type {StaticImageData} from 'next/legacy/image';
import type {ReactNode} from 'react';

import {Typography, VARIANTS} from '@/components/base/typography/Typography';
import Image from '@/components/common/image/Image';

import styles from './Card.module.css';

export type CardProps = {
	id: number;
	title: string | ReactNode;
	desc: string | ReactNode;
	image: StaticImageData;
};

export function Card({title, desc, image}: CardProps) {
	return (
		<li className={styles.card}>
			<div className={styles.imageBlock}>
				<Image src={image} alt={title} />
			</div>
			<div className={styles.content}>
				<Typography className={styles.title} variant={VARIANTS.h2}>
					{title}
				</Typography>
				<Typography className={styles.description} variant={VARIANTS.text}>
					{desc}
				</Typography>
			</div>
		</li>
	);
}
